<app-header></app-header>

<main class="layout-content">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
